import './image-slider.scss';

class ImageSlider {
    constructor(element, options) {
        const settings = {
            resizeTimeout: 150
        };

        this.settings = Object.assign({}, settings, options);

        this.$imageSlider = element;
        this.activeFullscreen = false;
        this.fullscreenOverlay = null;

        this.initialize();
    }

    initialize () {
        let $imageSliderClone = this.$imageSlider.cloneNode(true);

        import ('../../components/slider/slider').then(( { Slider }) => {
            const imageSlider = new Slider(this.$imageSlider, {
                effect: 'fade', 
                fullscreen: true, 
                speed: 500, 
                slidesPerView: 1, 
                slidesPerGroup: 1,
                initAttr: 'data-imageslider',
                onFullscreen: (currentSlide) => {
                    if (this.activeFullscreen !== true) {
                        this.activeFullscreen = true;
                        let $fullscreenImageSlider = $imageSliderClone.cloneNode(true);

                        let $fullscreen = document.createElement('dialog');
                        $fullscreen.setAttribute('aria-modal', 'true');
                        $fullscreen.classList.add('site-fullscreen');

                        this.fullscreenOverlay = $fullscreen;

                        let $fullscreenSlides = $fullscreenImageSlider.querySelectorAll('[data-imageslider="slide"]');

                        for (let i = 0; i < $fullscreenSlides.length; i++) {
                            let $currentSlide = $fullscreenSlides[i];
                            let imageUri = $currentSlide.querySelector('[data-imageslider="fullscreen-data"]').getAttribute('data-zoom');

                            let $currentCaption = null;

                            if ($currentSlide.querySelector('[data-imageslider="caption"]')) {
                                $currentCaption = $currentSlide.querySelector('[data-imageslider="caption"]').innerHTML;
                            }

                            let $fullscreenImage = document.createElement('figure');
                            $fullscreenImage.classList.add('fullscreen-image');

                            let $fullscreenImageWrap = document.createElement('span');
                            let $image = document.createElement('img');
                            $image.setAttribute('src', imageUri);

                            let $fullscreenCaption;

                            if ($currentCaption != null) {
                                $fullscreenCaption = document.createElement('figcaption');
                                $fullscreenCaption.innerHTML = $currentCaption;

                                $fullscreenImage.appendChild($fullscreenCaption);
                            }

                            $fullscreenImageWrap.appendChild($image);

                            $fullscreenImage.appendChild($fullscreenImageWrap);


                            $currentSlide.innerHTML = '';
                            $currentSlide.appendChild($fullscreenImage);
                        }

                        $fullscreen.appendChild($fullscreenImageSlider);

                        document.querySelector('body').appendChild($fullscreen);
                        this.fullScreenBodyLock(true);

                        window.setTimeout(() => {
                            $fullscreen.classList.add('is--visible');

                            const $fullscreenToggle = $fullscreen.querySelector('[data-imageslider="fullscreen"]');

                            if ($fullscreenToggle) {
                                window.setTimeout(() => {
                                    $fullscreenToggle.focus();
                                }, 150);
                            }
                        }, 150);

                        document.addEventListener('keydown', (event) => {
                            if (event.code === 'Tab' || event.code === 'Tabs') {
                                this.handleOutsideClick(event);
                            }

                            if (event.code === 'Esc' || event.code === 'Escape') {
                                this.handleEscape(event);
                            }
                        });

                        new Slider($fullscreenImageSlider, {
                            effect: 'fade',
                            fullscreen: true,
                            speed: 500,
                            slidesPerView: 1,
                            slidesPerGroup: 1,
                            initAttr: 'data-imageslider',
                            initialSlide: currentSlide,
                            onSlidePrev: () => {
                                imageSlider.sliderPrev();
                            },
                            onSlideNext: () => {
                                imageSlider.sliderNext();
                            },
                            onFullscreen: () => {
                                this.closeFullscreen();
                            }
                        });
                    }
                }
            });
        });
    }

    fullScreenBodyLock (active) {
        const $bodyContainer = document.body;

        if ($bodyContainer) {
            if (active === true) {
                $bodyContainer.classList.add('body-locked');
            } else {
                $bodyContainer.classList.remove('body-locked');
            }
        }
    }

    handleOutsideClick (e) {
        if (this.fullscreenOverlay !== null) {
            if (!this.fullscreenOverlay.contains(e.target) && this.activeFullscreen === true) {
                this.closeFullscreen();
            }
        }
    }

    handleEscape () {
        if (this.fullscreenOverlay !== null && this.activeFullscreen === true) {
            this.closeFullscreen();
        }
    }

    closeFullscreen () {
        this.fullscreenOverlay.classList.remove('is--visible');
        this.activeFullscreen = false;
        this.fullScreenBodyLock(false);

        window.setTimeout(() => {
            this.fullscreenOverlay.parentNode.removeChild(this.fullscreenOverlay);
            this.fullscreenOverlay = null;
            const $fullscreenToggle = this.$imageSlider.querySelector('[data-imageslider="fullscreen"]');

            if ($fullscreenToggle) {
                $fullscreenToggle.focus();
            }
        }, 500);
    }
}

export { ImageSlider };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const context = eventDetails.$context;

    if (context) {
        const $$imageSlider = context.querySelectorAll('[data-imageslider="root"]');
        for (let i = 0; i < $$imageSlider.length; i++) {
            const $imageSlider = $$imageSlider[i];
            const imageSliderAPI = new ImageSlider($imageSlider);
            $imageSlider.imageSliderAPI = imageSliderAPI;
        }
    }
});
